import { Fragment } from "react";
import styled from "styled-components";
import { CgEye } from "react-icons/cg";
import ApiIcon from "@mui/icons-material/Api";
import { useNavigate } from "react-router-dom";
import { Grid, IconButton, Tooltip } from "@mui/material";

import pages from "../../../constants/pages";
import { Chip, Search } from "../../../components";
import MuiTable from "../../../components/MuiTable";
import { colors } from "../../css components/Style";

const Icon = styled(IconButton)`
  border: 1px solid ${colors.purple}!important;
  color: ${colors.purple}!important;
  height: 35px;
  width: 35px;
  margin: 0 5px;
  padding: 0 5px;
  &:hover {
    border: 1px solid ${colors.purple}!important;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

export default function List({ campaignList, setPage, setSearchKey, loading }) {
  const navigate = useNavigate();

  var columns = [
    {
      name: "dial_id",
      label: "Dial ID",
    },

    {
      name: "config_name",
      label: "Name",
    },

    {
      name: "field_count",
      label: "Field Count",
    },

    {
      name: "active",
      label: "Status",
    },

    {
      name: "action",
      label: "Action",
    },
  ];

  const renderCell = (col, value, row) => {
    if (col.active) {
      return <Chip label={value ? "Active" : "Inactive"} />;
    }
    if (col.name === "action") {
      return (
        <div>
          <Tooltip title="View Field details">
            <Icon
              onClick={() =>
                navigate(pages.detailsLeadCampaign.route + row.dial_id)
              }
            >
              <CgEye style={{ height: "20px", width: "20px" }} />
            </Icon>
          </Tooltip>

          {row.api_details && (
            <Fragment>
              <Tooltip title="View API Details">
                <Icon
                  onClick={() =>
                    navigate(pages.apiLeadCampaignDetails.route + row.dial_id)
                  }
                >
                  <ApiIcon style={{ height: "20px", width: "20px" }} />
                </Icon>
              </Tooltip>
            </Fragment>
          )}
        </div>
      );
    }

    return value; // default
  };

  return (
    <Grid container spacing={8}>
      <Grid size={12} />
      <Grid size={12}>
        <MuiTable
          loading={loading}
          components={[
            <ToolBar setPage={setPage} setSearchKey={setSearchKey} />,
          ]}
          columns={columns}
          renderCell={renderCell}
          data={campaignList}
        />
      </Grid>
    </Grid>
  );
}

export function ToolBar({ setPage, setSearchKey }) {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "end",
      }}
    >
      <div>
        <Search setPage={setPage} setSearchKey={setSearchKey} />
      </div>
    </div>
  );
}
